import angular from 'angular';
import '../../../../services/cart';
import '../../../../filters/sum';
import _ from "lodash";

angular.module('folkeuni').component('cartProduct', {
  templateUrl: '/shop-dist/templates/cart-product.html',
  bindings:{
    product:'<',
    onUpdate: '&',
    state: '<'
  },
  controller: function (Cart, $location) {
      var $ctrl = this;

      $ctrl.ticketTypes = [];
      $ctrl.standardAmount = 0;
      $ctrl.standardAmountPrevious = 0;


      $ctrl.updateStandardAmount = function() {
        if(!$ctrl.state.loading) {
          $ctrl.state.loading = true;
          var allow = true;
          if($ctrl.standardAmount < 0) {
            $ctrl.standardAmount = 0;
          }

          if($ctrl.standardAmount == 0) {
            allow = confirm('Ønsker du at fjerne standard billeterne fra ' + $ctrl.product.name + '?');
          }

          if(allow) {
            Cart.update({ productId: $ctrl.product.id, courseId: $ctrl.product.courseId, quantity: $ctrl.product.discount.length + $ctrl.standardAmount})
            .then(function() {}, function(res) {
              
            });
          } else {
            $ctrl.standardAmount = $ctrl.standardAmountPrevious;
            $ctrl.state.loading = false;
          }
        }
      };

      $ctrl.removeProduct = function() {
        if(!$ctrl.state.loading) {
          $ctrl.state.loading = true;

          var allow = confirm('Ønsker du at fjerne alle billeterne for ' + $ctrl.product.name + '?');

          if(allow) {
            Cart.update({ productId: $ctrl.product.id, courseId: $ctrl.product.courseId, quantity: 0 })
            .then(function() {}, function(res) {
                if (window.Clerk != null) {
                  window.Clerk('cart', 'remove', $ctrl.product.id);
                }
            });
          } else {
            $ctrl.state.loading = false;
          }
        }
      };

      function getTicketTypes() {
        if(!$ctrl.product) {
          return [];
        }

        var types = $ctrl.product.quantity > $ctrl.product.discount.length ? [{type: 'Standard', name: 'Standard'}] : [];

        var discountTypes = _.chain($ctrl.product.discount)
        .map(function(discount) {
          return {
            type: discount.type,
            name: discount.name ? discount.name : discount.type
          };
        })
        .uniqBy('type')
        .value();

        types = types.concat(discountTypes);

        return types;
      };

      $ctrl.$onChanges = function(changes) {
        if(changes.product) {
          $ctrl.ticketTypes = getTicketTypes();
          $ctrl.standardAmount = $ctrl.product.quantity - $ctrl.product.discount.length;
          $ctrl.standardAmountPrevious = $ctrl.standardAmount;
        }
      };
  }
});
